import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importer vos fichiers JSON
import fr from './locales/fr/common.json';
import en from './locales/en/common.json';

// Vérifier que les traductions sont chargées
console.log('FR loaded:', fr);
console.log('EN loaded:', en);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: {
        translation: fr
      },
      en: {
        translation: en
      }
    },
    lng: 'fr', // Langue par défaut
    fallbackLng: 'fr',
    debug: true, // Met à true pour voir les erreurs dans la console
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;